export const DESKTOP = 'DESKTOP' as const;
export const MOBILE = 'MOBILE' as const;
export const MOBILE_LANDSCAPE = 'MOBILE_LANDSCAPE' as const;
export const TABLET = 'TABLET' as const;

export type Device =
  | typeof DESKTOP
  | typeof MOBILE
  | typeof MOBILE_LANDSCAPE
  | typeof TABLET;

export const Devices = {
  DESKTOP,
  MOBILE,
  MOBILE_LANDSCAPE,
  TABLET,
} as const;
